// Block ends and line breaks become a space, so paragraphs don't run together
// ('stop".Nationwide') once the tags are gone.
const BREAK = /<\/(p|li|h[1-6]|div|blockquote)\s*>|<br\s*\/?>/gi;

export default function tagRemove(data = '') {
    if (data === null) {
        return '';
    }
    return data
        .replace(BREAK, ' ')
        .replace(/(<([^>]+)>)/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
}
